<div class="content-wrapper" [style.overflow]="overflow" cdkScrollable>
  <ng-content />
</div>

<div class="resize-handle" #dragHandle (mousedown)="dragStart($event)">
  <div class="resize-handle-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g transform="rotate(90 12 12)">
        <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
      </g>
    </svg>
  </div>
</div>
